import { MaskedLines, Overline, Reveal, Section } from "./ui";

// Estrutura pronta para troca futura: label SITUAÇÃO REAL → DEPOIMENTO REAL,
// quote → fala real do cliente, closing → nome + salão.
const items = [
  {
    label: "Situação real",
    title: "Agenda fraca",
    quote: "Minha agenda abriu e eu não sei por onde começar.",
    explanation:
      "O MOM ajuda você a procurar primeiro clientes, retornos e oportunidades que já existem antes de sair baixando preço.",
    closing: "Uma situação. Uma missão.",
  },
  {
    label: "Situação real",
    title: "Tempo livre",
    quote: "Abriu 30 minutos no meu dia. O que eu faço agora?",
    explanation:
      "O MOM transforma o tempo disponível em uma missão compatível com aquele momento: comercial, organização, desenvolvimento ou até descanso consciente.",
    closing: "Menos improviso. Mais direção.",
  },
  {
    label: "Situação real",
    title: "Preciso fazer caixa",
    quote: "Preciso movimentar receita, mas não quero sair dando desconto.",
    explanation:
      "O MOM analisa o contexto e devolve uma ação prática usando clientes, produtos, horários e oportunidades que o salão já possui.",
    closing: "Primeiro oportunidade. Depois margem.",
  },
];

export default function Social() {
  return (
    <Section id="depoimentos" tone="white">
      <div className="text-center">
        <Overline>Histórias</Overline>
        <MaskedLines
          inView
          as="h2"
          className="mx-auto mt-5 max-w-2xl font-serif text-3xl font-medium leading-[1.15] tracking-tight text-hc-ink sm:text-4xl lg:text-5xl"
          lines={["Pare de decidir", <em key="d" className="italic text-mom-carmim">no escuro</em>]}
        />
        <Reveal delay={0.15}>
          <p className="mx-auto mt-5 max-w-xl font-dmsans text-sm leading-relaxed text-hc-mutedInk sm:text-base">
            Veja situações em que o MOM entra em ação.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-3">
        {items.map((item, i) => (
          <Reveal key={i} delay={i * 0.1} className="flex flex-col rounded-3xl bg-white p-8 shadow-[0_20px_60px_rgba(0,0,0,0.05)] sm:p-10">
            <p className="font-dmsans text-[10px] font-semibold uppercase tracking-[0.24em] text-mom-vinho">
              {item.label}
            </p>
            <h3 className="mt-4 font-serif text-2xl font-semibold tracking-tight text-hc-ink">
              {item.title}
            </h3>
            <p data-testid={`situacao-real-${i}`} className="mt-5 font-serif text-lg font-medium italic leading-snug text-hc-ink">
              “{item.quote}”
            </p>
            <p className="mt-5 font-dmsans text-sm leading-relaxed text-hc-mutedInk">
              {item.explanation}
            </p>
            <div className="mt-auto pt-6">
              <p className="border-t border-dashed border-black/10 pt-5 font-dmsans text-[11px] font-semibold uppercase tracking-[0.16em] text-mom-carmim">
                {item.closing}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
